export interface AyudTesisPeriodoDTO{
    idInvAyudTesis: number;
    idPersona: number;
    idPeriodo: number;
    fechaAperturaAyud: Date;
    fechaAperturaTesis: Date;
    fechaCierreAyud: Date;
    fechaCierreTesis: Date;
    estado: number;
}

export function VoidAyudTesisPeriodoDTO():AyudTesisPeriodoDTO{
  return{
    idInvAyudTesis: 0,
    idPersona: 0,
    idPeriodo: 0,
    fechaAperturaAyud: new Date,
    fechaAperturaTesis: new Date,
    fechaCierreAyud: new Date,
    fechaCierreTesis: new Date,
    estado: 0,
  }  
}